// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"480":"ef4c497a719703947be1","785":"61f2af53cc9af6dc5805"}[chunkId] + ".js";
};